<template>
  <div :class="classes">
    <label :for="`label-${_uid}`" class="trbo-a-input-item__label">{{ input.label }}</label>
    <div class="trbo-a-input-item__content">
      <input
        :id="`label-${_uid}`"
        :value="value"
        :placeholder="input.placeholder"
        :aria-invalid="ariaInvalid"
        v-bind="inputAttributes"
        class="trbo-a-input-item__input"
        @input="handleChange"
        @invalid="handleInvalid"
      >
      <div v-if="icon" class="trbo-a-input-item__icon">
        <icon :name="icon" class="trbo-a-input-item__icon__image" />
      </div>
    </div>
  </div>
</template>

<script>
// @flow

import Icon from '../../../Icon/Icon.vue'

export default {
  components: {
    Icon
  },
  props: {
    input: {
      type: Object, // MultipleInputDataItem
      required: true
    },
    value: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      ariaInvalid: false
    }
  },
  computed: {
    classes () {
      return {
        'trbo-a-input-item': true,
        'trbo-a-input-item--with-icon': !!this.icon
      }
    },
    inputAttributes (): Object {
      const attributes = {
        email: {
          type: 'email',
          inputmode: 'email',
          required: true,
          autocomplete: 'email'
        },
        phone_number: {
          type: 'tel',
          inputmode: 'tel',
          required: true,
          autocomplete: 'tel'
        },
        number: {
          type: 'text',
          inputmode: 'numeric',
          pattern: '[\\d.,]*',
          required: true,
          autocomplete: 'on'
        },
        date: {
          type: 'date',
          required: true,
          autocomplete: 'on'
        },
        text: {
          type: 'text',
          required: true,
          autocomplete: 'on'
        }
      }
      return attributes[this.input.type]
    },
    icon (): ?string {
      const icons = {
        email: 'mail',
        phoneNumber: 'phone'
      }

      return icons[this.input.type] ?? ''
    }
  },
  methods: {
    handleChange (event) {
      this.ariaInvalid = false
      this.$emit('input', event.target.value)
    },
    handleInvalid (event) {
      this.ariaInvalid = 'true'
    }
  }
}
</script>

<style scoped src="./input-item.scss" />
